var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMfaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.33333L12 0L23 5.33333C23 12.2576 19.1716 22.0131 12 24C4.82839 22.0131 1 12.2576 1 5.33333Z",
    fill: "#A3C5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.4H14.5V9C14.5 7.8972 13.3785 7 12 7C10.6215 7 9.5 7.8972 9.5 9V9.4H9C8.73478 9.4 8.48043 9.48429 8.29289 9.63431C8.10536 9.78434 8 9.98783 8 10.2V14.2C8 14.4122 8.10536 14.6157 8.29289 14.7657C8.48043 14.9157 8.73478 15 9 15H15C15.2652 15 15.5196 14.9157 15.7071 14.7657C15.8946 14.6157 16 14.4122 16 14.2V10.2C16 9.98783 15.8946 9.78434 15.7071 9.63431C15.5196 9.48429 15.2652 9.4 15 9.4ZM10.5 9C10.5 8.3384 11.173 7.8 12 7.8C12.827 7.8 13.5 8.3384 13.5 9V9.4H10.5V9ZM12.5 12.4892V13.4H11.5V12.4892C11.2025 12.3508 11 12.0956 11 11.8C11 11.5878 11.1054 11.3843 11.2929 11.2343C11.4804 11.0843 11.7348 11 12 11C12.2652 11 12.5196 11.0843 12.7071 11.2343C12.8946 11.3843 13 11.5878 13 11.8C13 12.0952 12.7975 12.3504 12.5 12.4892Z",
    fill: "#F3FAFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfaIcon);
export default __webpack_public_path__ + "static/media/mfa-icon.9ca1c463.svg";
export { ForwardRef as ReactComponent };